import React from 'react'

type Props = {}

const BetdailyAppStepSevenIcon = (props: Props) => {
  return (
    <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_b_702_29)">
      <circle cx={24} cy={24} r={24} fill="url(#paint0_linear_702_29)" />
      <circle cx={24} cy={24} r={24} fill="url(#paint1_linear_702_29)" />
    </g>
    <g clipPath="url(#clip0_702_29)">
      <path
        d="M33.6739 30.199C34.674 31.1991 34.674 32.8215 33.6739 33.8216C32.6726 34.8212 31.0508 34.8212 30.0501 33.8216L25.0785 28.8493C23.5277 29.196 21.8366 28.7678 20.6326 27.5632C19.243 26.1736 18.9466 24.2086 19.4816 22.6289C19.5296 22.4903 19.7364 22.4787 19.8104 22.5527C19.8104 22.5527 22.6854 25.4283 22.6865 25.4288C23.0748 25.8177 23.708 25.8183 24.0968 25.4288L25.2859 24.2398C25.6741 23.8509 25.6736 23.2183 25.287 22.8288L22.4109 19.9556C22.3375 19.8822 22.3479 19.6742 22.4872 19.6274C24.0674 19.0947 26.0266 19.3911 27.4155 20.7806C28.6202 21.9841 29.0483 23.6753 28.7016 25.2255L33.6733 30.1984L33.6739 30.199ZM36.4425 21.9396L34.0985 21.5733C33.8426 20.5044 33.4225 19.5003 32.8644 18.588L34.3181 16.5952C34.5012 16.345 34.4718 15.9602 34.2516 15.7412L32.2578 13.7473C32.0388 13.5278 31.6546 13.4983 31.4038 13.6809L29.4111 15.1352C28.4994 14.5776 27.4947 14.1564 26.4264 13.901L26.0601 11.557C26.0115 11.2508 25.7186 11 25.4089 11H22.5894C22.2798 11 21.9868 11.2508 21.9383 11.557L21.572 13.901C20.5031 14.1564 19.4996 14.5776 18.5867 15.1352L16.5946 13.6809C16.3438 13.4983 15.9596 13.5278 15.7406 13.7473L13.7468 15.7412C13.5272 15.9608 13.4972 16.345 13.6803 16.5952L15.1345 18.588C14.5764 19.4997 14.1558 20.5039 13.8999 21.5733L11.557 21.9391C11.2502 21.987 10.9989 22.28 10.9989 22.5902V25.4098C10.9989 25.72 11.2502 26.013 11.557 26.0604L13.8999 26.4267C14.1564 27.495 14.577 28.5003 15.1345 29.4115L13.6803 31.4042C13.4972 31.6544 13.5266 32.0392 13.7468 32.2588L15.7406 34.2521C15.9596 34.4711 16.3438 34.5011 16.5946 34.318L18.5867 32.8637C19.499 33.4218 20.5031 33.8424 21.572 34.0984L21.9377 36.4419C21.9863 36.7481 22.2786 36.9988 22.5889 36.9988H25.4084C25.718 36.9988 26.011 36.7481 26.0595 36.4419L26.4258 34.0984C26.7909 34.0112 27.1486 33.9037 27.4981 33.7789L25.2541 31.5348C24.845 31.6024 24.4273 31.6463 23.9986 31.6463C19.7752 31.6463 16.3513 28.2224 16.3513 23.9994C16.3513 19.7764 19.7769 16.3531 24.0003 16.3531C28.2238 16.3531 31.6471 19.777 31.6471 24.0006C31.6471 24.5177 31.5945 25.0221 31.4963 25.5109L33.6999 27.7145C33.8593 27.298 33.9934 26.8681 34.0985 26.4278L36.4425 26.0615C36.7493 26.0136 37.0001 25.7206 37.0001 25.4109V22.5914C37.0001 22.2811 36.7499 21.9882 36.4431 21.9408L36.4425 21.9396Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_702_29"
        x={-4150}
        y={-4150}
        width={8348}
        height={8348}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2075} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_702_29"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_702_29"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_702_29"
        x1={0}
        y1={0}
        x2={47.0669}
        y2={2.39871}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6F6DE6" />
        <stop offset={0.489583} stopColor="#5451D4" />
        <stop offset={1} stopColor="#312DB9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_702_29"
        x1={24}
        y1={0}
        x2={24}
        y2={48}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B21318" />
        <stop offset={1} stopColor="#7D0204" />
      </linearGradient>
      <clipPath id="clip0_702_29">
        <rect
          width={26}
          height={26}
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
  )
}

export default BetdailyAppStepSevenIcon